export const GET_DATA_REQUEST = "GET_DATA_REQUEST"; 
export const GET_DATA_SUCCESS = "GET_DATA_SUCCESS"; 
export const GET_DATA_FAILED = "GET_DATA_FAILED"; 

export const POST_DATA_REQUEST = "POST_DATA_REQUEST"; 
export const POST_DATA_SUCCESS = "POST_DATA_SUCCESS"; 
export const POST_DATA_FAILED = "POST_DATA_FAILED"; 

export const PATCH_DATA_REQUEST = "PATCH_DATA_REQUEST"; 
export const PATCH_DATA_SUCCESS = "PATCH_DATA_SUCCESS"; 
export const PATCH_DATA_FAILED = "PATCH_DATA_FAILED"; 

export const DELETE_DATA_REQUEST = "DELETE_DATA_REQUEST"; 
export const DELETE_DATA_SUCCESS = "DELETE_DATA_SUCCESS"; 
export const DELETE_DATA_FAILED = "DELETE_DATA_FAILED"; 